import enTranslations from "@/lang/en";

export default {
  en: enTranslations,
} as const;
